const socialNetworkUrls = {
    instagram: 'https://www.instagram.com/',
    facebook: 'https://www.facebook.com/',
    linkedin: 'https://www.linkedin.com/',
    youtube: 'https://www.youtube.com/',
    twitter: 'https://www.x.com/',
};

export function getWhatsAppUrl(phone, message = '') {
    const digits = String(phone ?? '').replace(/\D/g, '');
    if (!digits) return '';

    const internationalPhone = digits.startsWith('55') || digits.startsWith('54')
        ? digits
        : `55${digits}`;
    const query = message ? `?text=${encodeURIComponent(message)}` : '';

    return `https://wa.me/${internationalPhone}${query}`;
}

export function getSocialUrl(network, value) {
    const baseUrl = socialNetworkUrls[network];
    const account = String(value ?? '').trim();
    if (!baseUrl || !account) return '';
    if (/^https?:\/\//i.test(account)) return account;

    return `${baseUrl}${account.replace(/^@/, '').replace(/^\/+|\/+$/g, '')}`;
}
